module.exports = "<div class=\"kl-loading {class}\" r-class={ {'kl-loading--static': static, 'kl-loading--fixed': !static} } r-hide={!visible}\n  r-animation=\"on:enter;class:animated fadeIn; on:leave;class:animated fadeOut\">\n    <svg class=\"kl-loading__circular\" viewBox=\"25 25 50 50\">\n      <circle class=\"kl-loading__path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\"/>\n    </svg>\n    {#if this.$body}\n      {#inc this.$body}\n    {/if}\n</div>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/widget/KLLoading/index.html
// module id = 530
// module chunks = 0